import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import download from 'downloadjs'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";

import {BasicSelect} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'stocktransfer',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		download,
		Loader,
		BasicSelect
	},
	data: function() {
		return {
			// totalRows: 0,
			// currentPage: 0,
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			resultCount: 0,
			searchFlag: false,
			useremail: '',
			status: '',
			awbno: '',
			transporter: '',
			orderid: '',
			fromdate: '',
			todate: '',
            brand:'',
			listRTOData: [],
			listRTODataCsv: [],

			listClientData: [],
			listWarehouseData: [],
			// pageno: 0,
			// totalPage: 0,
			// pageLimit: 5,
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 5,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			showSelectMerchant:false,
			ClientErr: '',
			WarehouseErr: '',
			listMerchantData: [],
			csvFields: '',
			merchantname: '',
			listTransporterData: [],
			isLoading: false,
			formattedDate: '',
			userid: '',
			recordLimit: 0,
			limitExeed: false,
			searchstatus:'',
			rtostatuslist:[
				{
	        'status': 'Received'
	      },{
	        'status': 'rackin'
	      },{
	        'status': 'WHInscan'
	      },
			],

			item:{
				value:'',
				text:''
			  },
			  listMerchantData1: [{value:'',text: this.$t('common.selectMerchantPlaceHolder')}],
				activemrpflag:false,
		}
	},

	created: function() {},
	computed: {},

	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail.email;
		this.userid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.getTransporterList();
		this.reportname = this.$t('editedjson.rtoReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');
		this.calldateFunction()
		//console.log(this.formattedDate);
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantList()
		this.getTransporterList()
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant=true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				this.getActiveMrpFlag();
				this.showSelectMerchant=true;
				this.showSelectWarehouse = true;
				if(userdetail.merchantid){
				this.mid=userdetail.merchantid.toString()
				this.merchantname=this.mid
				this.showSelectWarehouse = true;
				this.showSelectMerchant=false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant=true;

				//this.warehouse=this.warehouseid ;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		} //END SWITCH

		this.getRecordLimit();
		this.calldateFunction();

	},
	methods: {
		reset () {
			this.item = {}
		},
		onSelect(item) {
			// select option from parent component
		this.item = item
		this.merchantname=item.value;
		},
		calldateFunction() {
			//console.log("sagar")
            this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
            this.todate = this.currentDate;
            var dt = new Date(this.currentDate);
            dt.setDate(dt.getDate() - 6);
            this.fromdate = dt;

        },


		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		payloaddateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getRtoReportDataForXls(3)
			}
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		getTransporterList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;

			this.input = ({});

			axios({
					method: 'GET',
					'url': apiUrl.api_url + 'courierlistRTO',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listTransporterData = result.data.rows;
				}, error => {
					console.error(error);
				});
		},

		// clientSelected() {

		// 	if (this.clientid != this.client) {
		// 		console.log(this.merchantname)
		// 		this.clientid = this.client;
		// 		this.pageno = 0;
		// 		this.merchantname = '';
		// 		this.totalPage = 0;
		// 		this.currentPage = 1
		// 		this.resultCount = 0;
		// 		this.listRTOData = [];
		// 		this.getWarehouseList();
		// 		this.getMerchantList();
		// 		this.getActiveMrpFlag();
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		}
		// 	}
		// 	this.searchFlag=false;
		// 	this.clientid = this.client;
		// 	if (this.clientid) {
		// 		if (this.warehouseid == '') {
		// 			this.getWarehouseList();
		// 			this.getActiveMrpFlag();
		// 		}
		// 	}
		// },

		// warehouseSelected() {
		// 	if (this.warehouseid != this.warehouse) {
		// 		this.listRTOData = [];
		// 		this.pageno = 0;
		// 		this.currentPage = 1
		// 		this.totalPage = 0;
		// 		this.resultCount = 0;
		// 	}
		// 	this.warehouseid = this.warehouse;
		// 	if (this.warehouseid) {
		// 		if (this.clientid == '') {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantListArray = [];
						result.data.forEach(function(item) {
							merchantListArray[item.merchantid] = item.merchantname;
						});
						this.merchantList = merchantListArray;
						this.item={
							value:'',
							text:''
							},
						   this.listMerchantData1=[{value:'',text: this.$t('common.selectMerchantPlaceHolder')}]
									  this.listMerchantData.forEach(ele=>{
										  this.listMerchantData1.push({
											"value":ele.merchantid,
											"text":ele.merchantname

										  })
										})
					}
				}, error => {
					console.error(error)
				})
		},
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": localStorage.getItem("selectedClient"),
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
		getRTOListSearchData() {
			this.currentPage = 1;
			this.getRTOListSearch(2);
		},
		getRTOListSearch(csvCheck = 0) {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.totalPage = 0;
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.totalPage = 0;
				return false;
			}
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.searchFlag = true;

			if (this.fromdate == "" || this.fromdate == null) {
				var fromdate = '';
			} else {
				var fromdate = this.payloaddateFormat(this.fromdate) + ' 00:00:00'
			}

			if (this.todate == "" || this.todate == null) {
				var todate = '';
			} else {
				var todate = this.payloaddateFormat(this.todate) + ' 23:59:00';
			}
			this.input = ({
				offset: (this.currentPage - 1) * 5,
				limit: this.pageLimit,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				awbno: this.awbno,
				transporter: this.transporter,
				orderid: this.orderid,
				clientid: localStorage.getItem("selectedClient"),
				merchant: this.merchantname,
				fromdate: fromdate,
				todate: todate,
				brand:this.brand,
				searchstatus:this.searchstatus,
			});
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getDataForReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false
					this.resultCount = 0;
					this.listRTOData = [];
					this.listRTOData = result.data.data;
					this.resultCount = result.data.count;
					this.totalRows = result.data.count
					if (Number(this.totalRows) > Number(this.recordLimit)) {
						this.limitExeed = true
					}
					if (result.data.count == 0) {
						this.totalPage = 0
					} else {
						if (this.totalRows <= this.pageLimit) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
				}, error => {
					console.error(error)
				})
		},
		//to get Sales Report list
		getRtoReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fromdate = '';
			var todate = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = true;
				this.download = false;
			}
			if (this.fromdate == "" || this.fromdate == null) {
				var fromdate = '';
			} else {
				var fromdate = this.payloaddateFormat(this.fromdate) + ' 00:00:00'
			}

			if (this.todate == "" || this.todate == null) {
				var todate = '';
			} else {
				var todate = this.payloaddateFormat(this.todate) + ' 23:59:00';
			}
			this.input = ({
				warehouseid: localStorage.getItem("selectedClient"),
				awbno: this.awbno,
				transporter: this.transporter,
				orderid: this.orderid,
				clientid: localStorage.getItem("selectedClient"),
				merchant: this.merchantname,
				fromdate: fromdate,
				todate: todate,
				userid: this.userid,
				brand:this.brand,
				csvData: csvCheck

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			this.isLoading = true;

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getDataForReportCsv',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.data.length > 0) {
						this.show = true;
						this.download = false;
						this.csvFields = {
							'rtoid': this.$t('shipment.rtoId'),
							'createddatetime': this.$t('editedjson.rtoDate'),
							'awbno': this.$t('common.awbNo'),
							'orderid': this.$t('common.orderID'),
							'transporter': this.$t('ShippingDetails.transporter'),
							'status': this.$t('editedjson.rtoStatus'),
							'orderitemsequence': this.$t('editedjson.salesOrderItemId'),
							'productid': this.$t('common.productId'),
							'brand': this.$t('common.brand'),
							'eancode': this.$t('common.eanCode'),
							'mrp': this.$t('common.mrp'),
							'activemrp': this.$t('common.activemrp'),
							'quantity': this.$t('common.totalQuantity'),
							'accepted_qty': this.$t('common.acceptedQuantity'),
							'rejected_qty': this.$t('common.rejectedQuantity'),
							'rackin_accepted_qty': this.$t('returnReceiptReport.acceptedPutAwayQuantity'),
							'rackin_rejected_qty': this.$t('returnReceiptReport.rejectedPutAwayQuantity'),
							'saleschannel': this.$t('common.salesChannel'),
							'merchantname': this.$t('common.merchantName'),
							'recived_qty': this.$t('returnReceiptReport.receivedQuantity'),
							'short_quantity': this.$t('returnReceiptReport.shortQuantity'),
							'rejected_reason' : this.$t('common.rejectReason'),
							'modifiedby' : this.$t('editedjson.modifiedBy'),
							'modeifieddatetime' : this.$t('editedjson.modifiedDatetime'),
							'inscanby' : this.$t('editedjson.inscanBy'),
							'inscandatetime' : this.$t('editedjson.inscanDatetime'),
							'grdoneby' : this.$t('editedjson.grDoneBy'),
							'grdonedatetime' : this.$t('editedjson.gRdatetime'),
							'rackindoneby' : this.$t('editedjson.rackInBy'),
							'rackindatetime' : this.$t('editedjson.rackInDatetime'),
						};
						var dateFilter = ['createddatetime','modeifieddatetime','inscandatetime','grdonedatetime','rackindatetime'];
						if(this.activemrpflag === true){
								var skipFilter = [];
						}else {
								var skipFilter = ['activemrp'];
						}
						this.listRTODataCsv = result.data.data;
						csvHelper.data.jsonToCSV(this.$t('editedjson.rtoReport'), this.listRTODataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						// this.jsonToCSV('rtoReport', this.listRTODataCsv, this.csvFields, dateFilter, skipFilter);
					} else {
						if (result.data.status == true) {
							this.$alertify.success(this.$t('common.reportSizeError'));
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}
					this.isLoading = false;

				}, error => {
					console.error(error)
				})

		},
		getRtoReportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fromdate = '';
			var todate = '';
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			if (this.fromdate == "" || this.fromdate == null) {
				var fromdate = '';
			} else {
				var fromdate = this.payloaddateFormat(this.fromdate) + ' 00:00:00'
			}

			if (this.todate == "" || this.todate == null) {
				var todate = '';
			} else {
				var todate = this.payloaddateFormat(this.todate) + ' 23:59:00';
			}
			this.input = ({
				warehouseid: localStorage.getItem("selectedWarehouse"),
				awbno: this.awbno,
				transporter: this.transporter,
				orderid: this.orderid,
				clientid: localStorage.getItem("selectedClient"),
				merchant: this.merchantname,
				fromdate: fromdate,
				todate: todate,
				userid: this.userid,
				csvData: csvCheck

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})


			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getDataForReportCsv',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls[this.$t('shipment.rtoId')]= 'rtoid';
							this.csvFieldsForXls[this.$t('editedjson.rtoDate')]= 'createddatetime';
							this.csvFieldsForXls[this.$t('common.awbNo')]= 'awbno';
							this.csvFieldsForXls[this.$t('common.orderID')]= 'orderid';
							this.csvFieldsForXls[this.$t('ShippingDetails.transporter')]= 'transporter';
							this.csvFieldsForXls[this.$t('editedjson.rtoStatus')]= 'status';
							this.csvFieldsForXls[this.$t('editedjson.salesOrderItemId')]= 'orderitemsequence';
							this.csvFieldsForXls[this.$t('common.productId')]= 'productid';
							this.csvFieldsForXls[this.$t('common.brand')]= 'brand';
							this.csvFieldsForXls[this.$t('common.eanCode')]= 'eancode';
							this.csvFieldsForXls[this.$t('common.mrp')]= 'mrp';
							if(this.activemrpflag === true){
								this.csvFieldsForXls[this.$t('common.activemrp')]= 'activemrp';
						  }
							this.csvFieldsForXls[this.$t('common.totalQuantity')]= 'quantity';
							this.csvFieldsForXls[this.$t('common.acceptedQuantity')]= 'accepted_qty';
							this.csvFieldsForXls[this.$t('common.rejectedQuantity')]= 'rejected_qty';
							this.csvFieldsForXls[this.$t('returnReceiptReport.acceptedPutAwayQuantity')]= 'rackin_accepted_qty';
							this.csvFieldsForXls[this.$t('returnReceiptReport.rejectedPutAwayQuantity')]= 'rackin_rejected_qty';
							this.csvFieldsForXls[this.$t('common.salesChannel')]= 'saleschannel';
							this.csvFieldsForXls[this.$t('common.merchantName')]= 'merchantname';
							this.csvFieldsForXls[this.$t('returnReceiptReport.receivedQuantity')]= 'recived_qty';
							this.csvFieldsForXls[this.$t('returnReceiptReport.shortQuantity')]= 'short_quantity';
							this.csvFieldsForXls[this.$t('common.rejectReason')]= 'rejected_reason';
							this.csvFieldsForXls[this.$t('editedjson.modifiedBy')]= 'modifiedby';
							this.csvFieldsForXls[this.$t('editedjson.modifiedDatetime')]= 'modeifieddatetime';
							this.csvFieldsForXls[this.$t('editedjson.inscanBy')]= 'inscanby';
							this.csvFieldsForXls[this.$t('editedjson.inscanDatetime')]= 'inscandatetime';
							this.csvFieldsForXls[this.$t('editedjson.grDoneBy')]= 'grdoneby';
							this.csvFieldsForXls[this.$t('editedjson.gRdatetime')]= 'grdonedatetime';
							this.csvFieldsForXls[this.$t('editedjson.rackInBy')]= 'rackindoneby';
							this.csvFieldsForXls[this.$t('editedjson.rackInDatetime')]= 'rackindatetime';
							this.listReportDataforxls = result.data.data;
							//console.log(this.listReportDataforxls);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}



				}, error => {
					console.error(error)
				})

		},
		//to reset search form
		resetFlt() {
			this.item={
				value:'',
				text:''
			  };
			this.searchstatus='';
			this.brand='',
			this.show = false;
			this.download = true;
			this.awbno = '';
			this.transporter = '';
			this.orderid = '';
			this.merchantname = '';
			this.searchFlag = false;
			this.listRTOData = [];
			this.totalPage = 0;
			this.pageno = 0;
			this.totalRows = 0;
			this.fromdate = '';
			this.todate = '';
			this.ClientErr = '';
			this.WarehouseErr = '';
			// if (this.user_type == 'warehouse_user') {
			// 	this.client = '';
			// 	this.clientid = ''
			// 	// this.listMerchantData1=[{value:'',text: this.$t('common.merchantPlaceholder')}];

			// } else if (this.user_type == 'client_user') {
			// 	this.warehouse = '';
			// 	this.warehouseid = ''
			// } else {
			// 	this.client = '';
			// 	this.clientid = ''
			// 	this.warehouse = '';
			// 	this.warehouseid=''
			// 	// this.listMerchantData1=[{value:'',text: this.$t('common.merchantPlaceholder')}];

			// }

		},


		//to get pagination
		// getPaginationData(currentPage) {
		//   this.pageno = (currentPage - 1) * this.pageLimit;
		//   this.getRTOListSearch();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getRTOListSearch()
		},
		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid')
			}).catch(() => {
				console.log('errors exist')
			});
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/rtoreport/rtoreport.component.js